import React from 'react';
import Preview from './Preview';
import { toCurrency, toPercent } from '../../../../utils/numbers';
import { METRIC_VALUES_LOOKUP } from './constants';
import { formatMetricValue } from '../../../DNA/utils';

const handleDataFormat = (x) => {
  if (typeof x === 'string' || !x) return 0;
  return Number(x);
};

const getVisualsStats = (arr, metric) => {
  return arr.reduce(
    ({ count, spend, metric_sum }, curr) => ({
      count: count + 1,
      spend: spend + handleDataFormat(curr.total_spend),
      metric_sum: metric_sum + handleDataFormat(curr[metric]),
    }),
    { count: 0, spend: 0, metric_sum: 0 }
  );
};

const parseSelectedVisuals = (strOrArr: string | string[]) => {
  if (!strOrArr) return [];
  if (typeof strOrArr === 'string') return strOrArr.split(',');
  return strOrArr;
};

const RightDisplay = ({
  hoveredVisual,
  height,
  isROAS,
  primary_metric,
  primaryMetricLabel,
  selectedVisuals = [],
  filteredVisuals,
  filteredAllVisualsLabel,
  columnDropdownOptions,
}) => {
  if (!hoveredVisual) return;

  const selectedVisualObjects = parseSelectedVisuals(selectedVisuals)
    .map((ad_name) => {
      return filteredVisuals.find((visual) => visual.ad_name === ad_name);
    })
    .filter((x) => !!x);

  const noneSelected = !selectedVisuals.length || !selectedVisuals[0];

  const all_stats = getVisualsStats(filteredVisuals, primary_metric);
  const stats = getVisualsStats(selectedVisualObjects, primary_metric);

  const avgPrimary = noneSelected
    ? all_stats.metric_sum / all_stats.count
    : stats.metric_sum / stats.count;

  const MetricSection = ({ title, value, show, children }) => {
    return (
      <div className={`metric-section ${show ? 'show' : ''}`}>
        {title && <div className="metric-section__title">{title}</div>}
        {value && <div className="metric-section__value">{value}</div>}
        {children}
      </div>
    );
  };

  const rows = document.getElementsByClassName('right-display__row');
  const rowsHeight =
    rows[0]?.getBoundingClientRect().height +
    rows[1]?.getBoundingClientRect().height;

  return (
    <div
      className="right-display"
      style={{ height: !!height ? `${height}px` : 'auto' }}
    >
      <div className="right-display__row">
        <MetricSection
          title={`${primaryMetricLabel} (${
            noneSelected ? 'All' : 'Selected'
          }\u00A0Creatives)`}
          value={formatMetric(primary_metric, avgPrimary)}
          show={true}
        />
        <MetricSection
          title={`${selectedVisuals.length ? '' : 'Total '}# of ${
            selectedVisuals.length ? 'Selected ' : ''
          }Creatives`}
          value={`${
            selectedVisuals.length
              ? selectedVisuals.length
              : [...filteredVisuals].length
          }`}
          show={true}
        />
      </div>
      {/* <div className="right-display__row">
        <MetricSection
          title={`% Spend on Below Average Performers (${
            selectedVisuals.length ? 'Selected' : 'All'
          }\u00A0Creatives)`}
          value={`${
            !noneSelected && selectedVisuals.length === 1
              ? 'N/A'
              : toPercent(percentSpendOnLosers)
          }`}
          show={true}
        />
      </div> */}
      <div
        className="right-display__row"
        // style={{ height: `${rowsHeight + 4}px` }}
      >
        <MetricSection title={null} value={null} show={!!hoveredVisual}>
          <Preview
            visual={hoveredVisual}
            isROAS={isROAS}
            primary_metric={primary_metric}
          />
        </MetricSection>
      </div>
    </div>
  );
};

export default RightDisplay;

export const formatMetric = (metric, value) => {
  if (!value) return '-';

  if (['total_cpa', 'total_spend', 'total_cpc', 'total_cpm'].includes(metric)) {
    return toCurrency(value);
  }
  return value.toFixed(2);
};
